<template>
 <!-- 发件人地址库弹框  -->
 <div class="dialogBox">
     	<el-dialog title="Consignee addresses" :visible.sync="dialogTableVisible" :close-on-click-modal="false" custom-class="borRad10" width="750px">
        <table border="0" cellspacing="0" cellpadding="0" class="listTable">
            <tr>
              <th width="6%"><p>No.</p></th>
              <th width="20%"><p>Company</p></th>
              <th width="15%"><p>Contact</p></th>
              <th width="45%"><p>Address</p></th>
              <th><p>Action</p></th>
            </tr>
            <tr v-for="(item,index) in addReceiveList" :key="index" v-if="addReceiveList.length> 0">
              <td>{{index+1}}</td>
              <td>{{item.company}}</td>
              <td>{{item.Address_Name}}</td>
              <td>
                <span v-if="item.Address_Street">{{item.Address_Street}}</span>
                <span v-if="item.Address_City">,{{item.Address_City}}</span>
                <span v-if="item.Address_ZIPCode">,{{item.Address_ZIPCode}}</span>
                <span v-if="item.Address_Country">,{{item.Address_Country}}</span>
              </td>
              <td>
                <a class="butChoose" @click="chooseAdd(item)">Select</a>
              </td>
            </tr>
            <tr v-if="addReceiveList.length <= 0">
              <td colspan="5" style="height:50px;"> <span class="colGray9" >No results</span> </td>
            </tr>
          </table>
      </el-dialog>
       </div>
        
</template>

<script type="text/ecmascript-6">
   import Vue from 'vue'  
  import {getCookie} from '../../../ask/cookiejs'
  import {post,fetch,Del,put} from '../../../ask/axios' 
  // import bus from '../../../ask/eventBus' 
  export default {
     data (){
        return {
        api: {
          url: "",
          param: "",
          data:"",
          response: {},
          message: ""
        },

        //收发件人信息
         dialogTableVisible:false,

         addReceiveList:[],

      }
     },

  created(){ //创建后

    },
    mounted(){ //载入dom后周期函数
      
    },
    watch:{//监听函数变化

    },
    computed:{//计算属性
    
 
     },

     //方法
    methods: {

      //-------------------------------收发件人，通知人信息---------------------------------//
      //
      clkDialog(){
        this.addReceiveAPIInfo();
        this.dialogTableVisible=true
      },
      //发件人地址栏接口数据
      addReceiveAPIInfo(){
        let that=this
        that.api.param={
          Page: 1,
          Size: 99999
        }
        // that.api.url=that.$api02+'/api/EbayCustomer/Addressee/List';
        that.api.url=that.$api04 + "/Basics/api/Addressee/List";
        post(that.api.url,that.api.param).then(function (res) {
          if(res.Results){
            that.addReceiveList=res.Results
          }
        })
      },

      //发件人地址库弹窗选择按钮
      chooseAdd(item){
        this.$emit('receiveMsgEvent',item)
        this.dialogTableVisible=false;
      },
        
     },
    
     
  }

</script>

<style type="text/css" rel="stylesheet" scoped="scoped">
@import "../../../assets/css/popupBox.css";

</style>



// WEBPACK FOOTER //
// src/components/userCenter/public/receiveAddrBox.vue